import { css } from '@emotion/react'

export const formFieldSpacing = css`
  @media (min-width: 768px) {
    margin-left: 17.06%;
  }
`
